import Vue from 'vue';

import App from './App.vue';
import HttpPlugin from './plugins/HttpPlugin';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

Vue.use(HttpPlugin);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
